import {forEach} from 'lodash';

import {generateGUID} from 'src/js/common/utils';

const LAYOUT_COMPONENT_CHILDREN = 'children';
const LAYOUT_COMPONENT_CONFIG = 'config';
const LAYOUT_COMPONENT_DATA = 'data';
const LAYOUT_COMPONENT_BOX_STYLE = 'boxStyle';
const LAYOUT_COMPONENT_CONTENT_STYLE = 'contentStyle';
const LAYOUT_COMPONENT_TITLE_STYLE = 'titleStyle';

const LAYOUT_COMPONENT_CONFIG_BORDER = 'border';
const LAYOUT_COMPONENT_CONFIG_TITLE = 'title';
const LAYOUT_COMPONENT_CONFIG_FILL_HEIGHT = 'fillHeight';

const LAYOUT_COMPONENT_DATA_ID = 'id';

const LAYOUT_CONFIG_COMPONENTS = 'components';

export class LayoutComponentConfig {
  constructor(rawData = {}) {
    this.rawData = rawData;
  }

  getBorder() {
    return !!this.rawData[LAYOUT_COMPONENT_CONFIG_BORDER];
  }

  getTitle() {
    return this.rawData[LAYOUT_COMPONENT_CONFIG_TITLE];
  }

  getFillHeight() {
    return this.rawData[LAYOUT_COMPONENT_CONFIG_FILL_HEIGHT];
  }

  getRawData() {
    return this.rawData;
  }
}

export class LayoutComponentData {
  constructor(rawData = {}) {
    this.rawData = rawData;
  }

  getId() {
    return this.rawData[LAYOUT_COMPONENT_DATA_ID];
  }

  getRawData() {
    return this.rawData;
  }
}

export class LayoutComponent {
  /* eslint-disable no-use-before-define */
  constructor(rawData = {}, id = undefined) {
    this.rawData = rawData;
    this.id = id;
    this.children = [];
    this.data = new LayoutComponentData(this.rawData[LAYOUT_COMPONENT_DATA]);
    this.config = new LayoutComponentConfig(
      this.rawData[LAYOUT_COMPONENT_CONFIG]
    );

    if (this.rawData && this.rawData[LAYOUT_COMPONENT_CHILDREN]) {
      this.children = LayoutConfig.initChildren(
        this.rawData[LAYOUT_COMPONENT_CHILDREN]
      );
    }
  }

  /* eslint-enable no-use-before-define */

  getId() {
    return this.id;
  }

  getBoxStyle() {
    return this.rawData[LAYOUT_COMPONENT_BOX_STYLE];
  }

  getContentStyle() {
    return this.rawData[LAYOUT_COMPONENT_CONTENT_STYLE];
  }

  getTitleStyle() {
    return this.rawData[LAYOUT_COMPONENT_TITLE_STYLE];
  }

  getConfig() {
    return this.config;
  }

  getData() {
    return this.data;
  }

  getChildren() {
    return this.children;
  }
}

export class LayoutConfig {
  static initChildren(rawChildren) {
    const children = [];

    if (rawChildren) {
      forEach(rawChildren, (child) => {
        children.push(new LayoutComponent(child, generateGUID()));
      });
    }

    return children;
  }

  static collectDataIds(components) {
    let dataIds = [];

    if (components) {
      forEach(components, (child) => {
        if (child.getData() && child.getData().getId()) {
          dataIds.push(child.getData().getId());
        }
        if (child.getChildren()) {
          dataIds = [
            ...dataIds,
            ...LayoutConfig.collectDataIds(child.getChildren()),
          ];
        }
      });
    }

    return dataIds;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.components = [];
    this.dataIds = [];
    if (this.rawData && this.rawData[LAYOUT_CONFIG_COMPONENTS]) {
      this.components = LayoutConfig.initChildren(
        this.rawData[LAYOUT_CONFIG_COMPONENTS]
      );
      this.dataIds = LayoutConfig.collectDataIds(this.components);
    }
  }

  getComponents() {
    return this.components;
  }

  getDataIds() {
    return this.dataIds;
  }
}

export default {LayoutConfig, LayoutComponent, LayoutComponentData};
